module.exports = __webpack_public_path__ + "static/media/resoluteai.482ceeb5.jpg";